// extracted by mini-css-extract-plugin
module.exports = {"root":"IconDiscount_root__1pmtA"};